import { Story } from '../../DocTypes';

export const clientPagingWithFilterStory: Story = {
  title: 'Client paging with filter',
  description: 'List with client paging and a client filter',
  coreComponent: {
    html: `<tag-combobox text-field='name' value-field='name'></tag-combobox>
  <tag-list
    height='250px'
    left-icon='CircleStar'
    left-icon-size='30'
    left-icon-accent='coral'
    primary-field='name'
    pager-accent='coral'>
  </tag-list>`,
    js: `var tagCombobox = document.querySelector('tag-combobox');
  var clubs = [
    { name: 'All' },
    { name: 'Everton' },
    { name: 'Man City' },
    { name: 'Man Utd' },
    { name: 'Tottenham' },
    { name: 'Liverpool' },
  ];
  tagCombobox.componentOnReady().then(function() {
    tagCombobox.setData(clubs);
    tagCombobox.value = 'All';
    tagCombobox.addEventListener('valueChange', function(e) {
      setListData(1, e.detail.value);
    });
  });

  var tagList = document.querySelector('tag-list');
  var players = [
    { name: 'Jordan Pickford', club: 'Everton' },
    { name: 'Kyle Walker', club: 'Man City' },
    { name: 'John Stones', club: 'Man City' },
    { name: 'Harry Maguire', club: 'Man Utd' },
    { name: 'Luke Shaw', club: 'Man Utd' },
    {
      name: 'Jordan Henderson',
      club: 'Liverpool',
    },
    { name: 'Harry Kane', club: 'Tottenham' },
    {
      name: 'Raheem Sterling',
      club: 'Man City',
    },
    { name: 'Mason Mount', club: 'Chelsea' },
    { name: 'Jack Grealish', club: 'Aston Villa' },
    { name: 'Marcus Rashford', club: 'Man Utd' },
    { name: 'Declan Rice', club: 'West Ham' },
    { name: 'Luke Shaw', club: 'Man Utd' },
  ];
  var pageSize = 5;

  function getListData(page, filter) {
    var currentFilter = filter || tagCombobox.value || 'All';
    var currentPage = page || tagList.page;
    var filteredPlayers =
      currentFilter === 'All'
        ? players.slice(0)
        : players.filter(function (p) { return p.club === currentFilter });
    var pageOfData = filteredPlayers.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    var recordCount = filteredPlayers.length;
    return {
      recordCount: recordCount,
      pageCount: Math.ceil(recordCount / pageSize),
      data: pageOfData,
    };
  }

  function setListData(page, filter) {
    var dataResult = getListData(page, filter);
    tagList.setData({
      page: page || tagList.page,
      pageSize: pageSize,
      pageCount: dataResult.pageCount,
      recordCount: dataResult.recordCount,
      data: dataResult.data,
    });
  }

  tagList.componentOnReady().then(function() {
    setListData();
    tagList.addEventListener('pageRequest', function(e) {
      setListData(e.detail.page);
    });
  });
  `,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const clubs = [
      { name: 'All' },
      { name: 'Everton' },
      { name: 'Man City' },
      { name: 'Man Utd' },
      { name: 'Tottenham' },
      { name: 'Liverpool' },
    ];
    const players = [
      { name: 'Jordan Pickford', club: 'Everton' },
      { name: 'Kyle Walker', club: 'Man City' },
      { name: 'John Stones', club: 'Man City' },
      { name: 'Harry Maguire', club: 'Man Utd' },
      { name: 'Luke Shaw', club: 'Man Utd' },
      {
        name: 'Jordan Henderson',
        club: 'Liverpool',
      },
      { name: 'Harry Kane', club: 'Tottenham' },
      {
        name: 'Raheem Sterling',
        club: 'Man City',
      },
      { name: 'Mason Mount', club: 'Chelsea' },
      { name: 'Jack Grealish', club: 'Aston Villa' },
      { name: 'Marcus Rashford', club: 'Man Utd' },
      { name: 'Declan Rice', club: 'West Ham' },
      { name: 'Luke Shaw', club: 'Man Utd' },
    ];

    const pageSize = 5;
    const [page, setPage] = React.useState(1);
    const [filter, setFilter] = React.useState('All');

    const filteredPlayers =
        filter === 'All'
          ? players.slice(0)
          : players.filter(p => p.club === filter);
    const pageOfData = filteredPlayers.slice((page - 1) * pageSize, page * pageSize);

    const recordCount = filteredPlayers.length;
    const pageCount = Math.ceil(recordCount / pageSize);

    return (
      <React.Fragment>
        <TagCombobox
          data={clubs}
          textField='name'
          valueField='name'
          value={filter}
          onValueChange={(e) => {
            setFilter(e.detail.value)
            setPage(1)
          }}
        />
        <TagList
          height='250px'
          leftIcon='CircleStar'
          leftIconSize='30'
          leftIconAccent='coral'
          primaryField='name'
          data={pageOfData}
          page={page}
          pageSize={pageSize}
          pageCount={pageCount}
          onPageRequest={(e) => setPage(e.detail.page)}
        />
      </React.Fragment>
    )
  };
  `,
  },
};
